export const SOFT_BLUE_GRADIENT_CLASS =
  'bg-[linear-gradient(135deg,color-mix(in_oklab,var(--color-primary)_7%,var(--color-card)),var(--color-card)_65%)]';
